import { render, staticRenderFns } from "./MediaAttachmentsPreview.vue?vue&type=template&id=46203790&scoped=true&"
import script from "./MediaAttachmentsPreview.vue?vue&type=script&lang=ts&"
export * from "./MediaAttachmentsPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MediaAttachmentsPreview.vue?vue&type=style&index=0&id=46203790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46203790",
  null
  
)

export default component.exports